module.exports = __webpack_public_path__ + "static/media/yotascale-logo-light-medium.ad1610a9.png";